import React from 'react';
import { useSelector } from 'react-redux';

import BuyNowPayLaterDetails from 'dpl/puppy_page/components/BuyNowPayLaterDetails';
import useToggle from 'dpl/shared/hooks/useToggle';

function PriceBreakdown() {
  const [isBreakdownVisible, toggleIsBreakdownVisible] = useToggle(false);

  const { priceRange, priceRangeWithDeposit, priceRangeDescription, deposit } =
    useSelector(({ server }) => server);

  return (
    <>
      <p className="font-16">{priceRangeDescription}</p>
      {isBreakdownVisible && Boolean(priceRange) && (
        <ul className="PriceBreakdown font-14">
          {deposit && (
            <li className="flex justify-between mt2">
              <p>Deposit</p>
              <p className="fw-medium">{deposit}</p>
            </li>
          )}
          {priceRange && (
            <li className="flex justify-between mt2">
              <p>Puppy payment</p>
              <p className="fw-medium">{priceRange}</p>
            </li>
          )}
          <li className="flex justify-between mt2">
            <p>Total</p>
            <p className="fw-medium">{priceRangeWithDeposit}</p>
          </li>
          <li className="mv4">
            <p className="secondary font-12">
              Includes vaccinations, deworming, a vet check, access to Good
              Dog’s Puppy Training Program (a $235 value), 10% lifetime discount
              on pet insurance, and more.
            </p>
          </li>
        </ul>
      )}
      {Boolean(priceRange) && (
        <button
          type="button"
          className="font-16 fw-medium stone-700 underline mt4"
          onClick={toggleIsBreakdownVisible}
        >
          {isBreakdownVisible ? 'Hide breakdown' : 'See price breakdown'}
        </button>
      )}
    </>
  );
}

export default function PuppyPricing() {
  const { acceptsBnplPayments, breederFirstName, priceRange } = useSelector(
    ({ server }) => server
  );

  return (
    <div className="PuppyPricing">
      <h4 className="font-24 lh-title pt2 mb6 w-90 mr2">Pricing</h4>
      <PriceBreakdown />
      {acceptsBnplPayments && Boolean(priceRange) && (
        <div className="font-16 mt4">
          <p>{breederFirstName} offers Klarna for payment flexibility.</p>
          <p>
            <BuyNowPayLaterDetails className="fw-medium stone-700" />
          </p>
        </div>
      )}
    </div>
  );
}
